<template>
  <v-container
    fullscreen
    persistent
    transition="dialog-bottom-transition">
    <v-card v-if="loading == 1">
      <v-card-title class="headline">Previous Shift Overview</v-card-title>
      <v-card-text>
        {{ startTime | formatDateTime}} - {{ endTime | formatDateTime}}
      </v-card-text>
    </v-card>
    <v-card class="mt-3">
      <v-container v-if="loading == 1">
        <v-subheader v-if="jobData.length > 0"
          >Jobs Completed In Selected Shift</v-subheader
        >
        <v-subheader v-else>No Jobs Completed In Selected Shift</v-subheader>
        <v-timeline align-top dense v-if="jobData.length > 0">
          <v-timeline-item
            v-for="(job, p) in jobData"
            :color="job.end_time == null ? 'green' : 'grey'"
            small
            :key="p"
          >
            <v-layout pt-2>
              <v-flex align-center>
                 <div class="subheading"><strong>{{ job.start_time|formatDate}} - {{job.end_time|formatDate}}</strong></div>
                  <div class="subheading">{{ job.start_time | filterJobTime }}-{{ job.end_time | filterJobTime }}
                  </div>
                  <div class="caption">{{ job|formattedJobLength }}</div>
                <div>
                  <div class="body-1">{{ job.farm_name }}</div>
                  <div class="caption">
                    {{ job.job_desc_name }} {{ job.product_name }}
                  </div>
                  <div :key="p" class="caption" v-if="job.spray_bonus != null">
                    {{ job.spray_bonus }} Hectares
                  </div>
                </div>
              </v-flex>
              <v-flex justify-end shrink>
                <v-btn
                  color="primary"
                  flat
                  icon
                  :to="'/JobDetails/' + taID + '/0/' + job.job_id"
                >
                  <v-icon medium>mode_edit</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-timeline-item>
        </v-timeline>
      </v-container>
      <v-container v-if="loading == 0">
        <v-layout justify-center>
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-layout>
      </v-container>
      <v-container v-if="loading == 2">
        <v-layout justify-center>
          <v-alert type="error">Error loading job details</v-alert>
        </v-layout>
      </v-container>
      <div v-if="anyJobInProgress"><strong class="red--text">Cannot add a new job until all jobs in selected shift have been closed</strong></div>
        <v-btn
          v-if="loading != 2"
          color="success"
          block
          :to="'/JobDetails/' + taID + '/0/-1'"
          :disabled="loading != 1 || anyJobInProgress"
          >Add Job</v-btn
        >
        <v-btn
          color="primary"
          block
          :disabled="loading != 1"
          :to="'/'">
          Back to Overview
        </v-btn>
      </v-card>
  </v-container>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
export default {
  props: ['taID'],
  data () {
    return {
      url: this.$store.getters.url,
      user: this.$store.getters.user,
      company: this.$store.getters.company,
      dateConfirmed: false,
      loading: 0, // 0 - loading, 1 - loaded, 2 - error
      jobData: [],
      startTime: '',
      endTime: ''
    }
  },
  mounted () {
    this.getJobDetails()
  },
  computed: {
    anyJobInProgress () {
      return this.jobData.some(job => job.end_time == null)
    }
  },
  methods: {
    getJobDetails () {
      this.loading = 0
      axios.post(this.url + `/tanda-service/getCurrentJobList.ajax.php`, {
        company: this.company,
        type: 'all',
        ta_id: this.taID,
        currentJobID: -1
      })
        .then(response => {
          this.startTime = moment.utc(response.data.shiftDetails.start_time).format('YYYY-MM-DD HH:mm')
          this.endTime = moment.utc(response.data.shiftDetails.end_time).format('YYYY-MM-DD HH:mm')
          this.jobData = response.data.jobDetails
          for (let job in response.data.jobDetails) {
            let currentJob = response.data.jobDetails[job]
            currentJob.start_time = moment.utc(currentJob.start_time, 'YYYY-MM-DD HH:mm:ss').local().format()
            if (currentJob.end_time == null) {
              this.jobStarted = true
              this.latestJobId = currentJob.job_id
            } else {
              currentJob.end_time = moment
                .utc(currentJob.end_time, 'YYYY-MM-DD HH:mm:ss')
                .local()
                .format()
            }
          }
          this.jobData.sort(
            (a, b) => new Date(b.start_time) - new Date(a.start_time)
          )
          this.loading = 1
        })
        .catch(e => {
          this.loading = 2
          console.log(e)
        })
    }
  },
  filters: {
    formattedJobLength (job) {
      if (job.end_time == null) {
        return ''
      }
      let hrs = moment(job.end_time).diff(moment(job.start_time), 'hours')
      let mins = moment(job.end_time).diff(moment(job.start_time), 'minutes') % 60
      console.log(job)
      console.log(hrs)
      return `${hrs}h ${mins}m`
    },
    formatDate (val) {
      return (val !== undefined && val !== null) ? moment(val).format('DD/MM/YYYY') : ''
    },
    formatDateTime (val) {
      return (val !== undefined && val !== null) ? moment(val).format('DD/MM/YYYY HH:mm') : ''
    },
    filterJobTime (val) {
      if (val == null) {
        return ''
      }
      return moment(val).format('HH:mm')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/JobOverview.vue